import Vue from 'vue'
import Vuex from 'vuex'
import setting from './setting'
import adminAuth from './adminAuth'
import csAuth from './csAuth'
import hotelAuth from './hotelAuth'
import taxiAuth from './taxiAuth'

// import example from './module-example'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default new Vuex.Store({
  modules: {
    adminAuth,
    csAuth,
    hotelAuth,
    taxiAuth,
    setting,
  },

  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV
})
